import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { fuseAnimations } from '../../../../../core/animations';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { IStudent } from '../../../../models/students/i-student';
import { Student } from '../../../../models/students/student';
import { StudentService } from '../../../../services/students/student.service';
import { FuseAddorEditStudentComponent } from './components/add-student/add-student.component';
import { DivisionService } from '../../../../services/divisions/division.service';
import { Tutor } from '../../../../models/tutors/tutor';
import { Division } from '../../../../models/divisions/division';
import { ReportService } from '../../../../services/reports/report.service';
import { environment } from '../../../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { StudentExcelConfigurationComponent } from './components/student-excel-configuration/student-excel-configuration.component';
import { ChangeCourseStudentComponent } from './components/change-course/change-course.component';
import { Payment } from '../../../../models/payment/payment';
import { DivisionPaymentComponent } from './components/divisions-payments/division-payment.component';
import { AddorEditPaymentComponent } from './components/payment/add-payment/add-payment.component';
import { HistoryStudentComponent } from './components/history/history-student.component';
import { ShiftService } from '../../../../services/shifts/shift.service';
import { CurriculumService } from '../../../../services/curricula/curriculum.service';
import { Shift } from '../../../../models/shifts/shift';
import { Curriculum } from '../../../../models/curricula/curriculum';
import { CourseYear } from '../../../../models/course-years/course-year';

@Component({
    selector: 'fuse-management-students',
    templateUrl: './students.component.html',
    styleUrls: ['./students.component.scss'],
    animations: fuseAnimations
})
export class StudentsComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['LastName', 'FirstName', 'DocumentNumber', 'Course', 'Actions'];
    studentDatabase;
    dataSource: StudentDataSource | null;
    confirmDialogRef: any;
    selectedDivisionId: number;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild('manually') manuallyCheck: ElementRef;
    public divisionsList: Division[];
    public divisionsFiltered: Division[];
    public divisionSelected = -1;
    private sub: any;

    public shifts = [];
    public curriculums = [];
    public curriculumSelected = -1;
    public shiftSelected = -1;

    constructor(
        private activatedRoute: ActivatedRoute,
        private authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private studentService: StudentService,
        private divisionService: DivisionService,
        private reportService: ReportService,
        private route: ActivatedRoute,
        public shiftService: ShiftService,
        public curriculumService: CurriculumService,
    ) {
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        this.sub = this.route.params.subscribe(params => {
            if (params['id'] !== undefined) {
                this.divisionSelected = +params['id']; // (+) converts string 'id' to a number
            }
        });

        Observable.combineLatest(
            this.shiftService.getAll(),
            this.curriculumService.getAll(),
            this.divisionService.getAllBySchoolYearId(this.authenticationService.getAuthData().SchoolYear.Id)
        ).subscribe(([shifts, curriculums, divisions]) => {
            this.shifts = [];
            if (this.shifts.find(e => e.Id === -1) === undefined) {
                const todos = new Shift();
                todos.Id = -1;
                todos.Description = 'Todos';
                this.shifts.push(todos);
            }

            shifts.forEach(e => {
                let found = this.authenticationService.getAuthData().Shifts.find(s => s.Id === e.Id);
                if (found) {
                    this.shifts.push(e);
                }
            });

            this.curriculums = [...curriculums];
            if (this.curriculums.find(e => e.Id === -1) === undefined) {
                const todos = new Curriculum();
                todos.Id = -1;
                todos.Description = 'Todos';
                this.curriculums.unshift(todos);
            }

            this.curriculumSelected = this.curriculums[0].Id;
            console.log(shifts);
            console.log(curriculums);


            this.divisionsList = [];

            if (this.divisionsList.find(e => e.Id === -1) === undefined) {
                const todos = new Division();
                todos.Id = -1;
                todos.DivisionName = 'Todos';
                this.divisionsList.push(todos);
            }

            divisions.forEach(e => {
                let found = this.authenticationService.getAuthData().Shifts.find(s => s.Id === e.ShiftId);
                if (found) {
                    this.divisionsList.push(e);
                }
            });

            this.filterDivisions();
        });

        console.log('this.authenticationService.getAuthData().SchoolYear.Id', this.authenticationService.getAuthData().SchoolYear.Id)
        this.studentDatabase = new StudentDatabase(this.studentService, this.authenticationService.getAuthData().SchoolYear.Id, this.authenticationService.getAuthData().Id, this.blockUI, this.translationService);
        this.dataSource = new StudentDataSource(this.studentDatabase, this.paginator, this.sort, this.divisionSelected);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }
                this.dataSource.filter = this.filter.nativeElement.value;
            });
    }

    filterShift(shiftId: number) {
        this.shiftSelected = shiftId;
        this.dataSource.filterShiftId(shiftId);
    }

    filterCurriculum(curriculumId: number) {
        this.curriculumSelected = curriculumId;
        this.dataSource.filterCurriculumId(curriculumId);
    }

    filterData() {
        this.filter = this.filter;
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    add() {
        const student = new Student();
        const tutor = new Tutor();
        student.Tutor = tutor;

        const config: MatDialogConfig = {
            // height: '75%',
            width: '80%',
            height: '90%',
            disableClose: true,
            data: {
                mode: 'new',
                student: JSON.parse(JSON.stringify(student))
            }
        };

        this.confirmDialogRef = this.dialog.open(FuseAddorEditStudentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentsComponent > add > result', result);
            if (result !== true) {
                this.studentDatabase.add(result);
            }
        });
    }

    editOrView(mode: string, student: IStudent) {
        console.log("SCHOOL YEAR ID CONFIGURADO------*************" + this.authenticationService.getAuthData().SchoolYear.Id);
        console.log(student.LastName);
        const config: MatDialogConfig = {
            // height: '75%',
            width: '80%',
            height: '90%',
            disableClose: true,
            data: {
                mode: mode,
                student: JSON.parse(JSON.stringify(student))
            }
        };

        this.confirmDialogRef = this.dialog.open(FuseAddorEditStudentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentComponent > editOrView > result', result);
            console.log('valorrr', (result !== true));
            console.log('mode', mode);
            if (result !== true) {
                if (mode === 'edit') {
                    this.studentDatabase.edit(result);
                }
            }
        });
    }

    loadPayments() {

        const config: MatDialogConfig = {
            // height: '75%',
            width: '40%',
            height: '90%',
            disableClose: true,
            data: {
                schoolYear: this.authenticationService.getAuthData().SchoolYear.Id,
                paymentDate: new Date()
            }
        };

        this.confirmDialogRef = this.dialog.open(DivisionPaymentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FusePayment > add > result', result);
        });
    }

    delete(student: IStudent) {
        this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', student.LastName + ' ' + student.FirstName, (res) => {
            this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
                this.studentService.delete(student.Id).subscribe(response => {
                    if (response.ResultCode === 1) {
                        this.studentDatabase.delete(student);
                        const index = this.studentService.students.findIndex(s => s.Id === student.Id);
                        if (index >= 0) {
                            this.studentService.students.splice(index, 1);
                            delete this.studentService.studentObject[student.Id];
                        }
                        this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                    } else {
                        this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                            this.sweetAlertService.error('Error', res, null);
                        });
                    }
                }, error => {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    });
                });
            }, () => {
                console.log('FuseStudentComponent > delete > canceled');
            });
        });
    }

    changeCourse(mode: string, student: IStudent) {
        console.log(student.LastName);
        const config: MatDialogConfig = {
            // height: '75%',
            width: '50%',
            height: '50%',
            disableClose: true,
            data: {
                mode: mode,
                student: JSON.parse(JSON.stringify(student))
            }
        };

        this.confirmDialogRef = this.dialog.open(ChangeCourseStudentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentComponent > editOrView > result', result);
            console.log('valorrr', (result !== true));
            console.log('mode', mode);
            if (result !== true) {
                if (mode === 'edit') {
                    this.studentDatabase.edit(result);
                }
            }
        });
    }

    addEditPayment(mode: string, student: IStudent) {
        console.log(student.LastName);
        const config: MatDialogConfig = {
            // height: '75%',
            width: '80%',
            height: '90%',
            disableClose: true,
            data: {
                mode: mode,
                student: JSON.parse(JSON.stringify(student))
            }
        };

        this.confirmDialogRef = this.dialog.open(AddorEditPaymentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentComponent > editOrView > result', result);
            console.log('valorrr', (result !== true));
            console.log('mode', mode);
            if (result !== true) {
                if (mode === 'edit') {
                    this.studentDatabase.edit(result);
                }
            }
        });
    }

    viewStudentHistory(mode: string, student: IStudent) {

        const config: MatDialogConfig = {
            // height: '75%',
            width: '80%',
            height: '90%',
            disableClose: true,
            data: {
                mode: 'view',
                student: JSON.parse(JSON.stringify(null)),
                docNumber: student.DocumentNumber
            }
        };

        this.confirmDialogRef = this.dialog.open(HistoryStudentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentComponent > editOrView > result', result);
            console.log('valorrr', (result !== true));
        });
    }

    searchHistory() {

        const config: MatDialogConfig = {
            // height: '75%',
            width: '80%',
            height: '90%',
            disableClose: true,
            data: {
                mode: 1,
                student: JSON.parse(JSON.stringify(null))
            }
        };

        this.confirmDialogRef = this.dialog.open(HistoryStudentComponent, config);

        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentComponent > editOrView > result', result);
            console.log('valorrr', (result !== true));
        });
    }

    filterStudents(divisionId: number) {
        this.selectedDivisionId = divisionId;
        this.dataSource.filterDivision(divisionId);
    }

    filterManuallyData(manually: boolean) {
        this.dataSource.filterDivisionByManually(manually);
    }

    printReportCard(siftId: number) {
        console.log(this.divisionSelected);
        if (siftId == -1) {
            if (this.studentDatabase.data.filter(e => e.DivisionId === this.divisionSelected).length < 1) {
                this.sweetAlertService.info('Info', 'No hay alumnos en esta división', null);
            } else {
                window.open(environment.backendUri + 'report/reportcard/' + this.divisionSelected, '_new');
            }
        } else {
            window.open(environment.backendUri + 'report/reportcardbyshift/' + siftId + '/' + this.authenticationService.getAuthData().SchoolYear.Id, '_new');
        }
    }

    filterDivisions() {
        this.divisionsFiltered = this.divisionsList;
        if (this.curriculumSelected != -1 && this.shiftSelected != -1) {
            this.divisionsFiltered = this.divisionsFiltered.filter(e => (e.CurriculumId == this.curriculumSelected && e.ShiftId == this.shiftSelected) || e.Id == -1)
        } else if (this.shiftSelected != -1) {
            this.divisionsFiltered = this.divisionsFiltered.filter(e => e.ShiftId == this.shiftSelected || e.Id == -1)
        } else if (this.curriculumSelected) {
            this.divisionsFiltered = this.divisionsFiltered.filter(e => e.CurriculumId == this.curriculumSelected || e.Id == -1)
        }
        this.divisionSelected = -1;
        console.log(this.divisionsFiltered);
        this.filterStudents(this.divisionSelected);
    }

    printStudentList(siftId: number) {
        if (siftId == -1) {
            if (this.studentDatabase.data.filter(e => e.DivisionId === this.divisionSelected).length < 1) {
                this.sweetAlertService.info('Info', 'No hay alumnos en esta división', null);
            } else {
                window.open(environment.backendUri + 'report/studentslist/' + this.divisionSelected, '_new');
            }
        } else { // imprimir todos las divisiones de todos los años
            window.open(environment.backendUri + 'report/studentslistbyshift/' + siftId + '/' + this.authenticationService.getAuthData().SchoolYear.Id, '_new');
        }
    }

    exportStudentsToExcel() {
        const config: MatDialogConfig = {
            width: '60%',
            maxWidth: '60%',
            maxHeight: '70%',
            height: '70%',
            disableClose: true,
            data: {
                schoolYearId: this.authenticationService.getAuthData().SchoolYear.Id
            }
        };

        this.confirmDialogRef = this.dialog.open(StudentExcelConfigurationComponent, config);
        this.confirmDialogRef.afterClosed().subscribe(result => {
            console.log('FuseStudentsComponent > add > result', result);
            if (result !== true) {
                this.studentDatabase.add(result);
            }
        });
    }

    exportRecepitsToExcel() {
        window.open(environment.backendUri + 'report/excel/studentreceipts/' + this.authenticationService.getAuthData().SchoolYear.Id, '_new');
    }

    refreshData() {
        this.blockUI.start('Cargando...')
        this.studentDatabase.refresh(() => {
            this.blockUI.stop();
        });
    }

    getSum(payments: Payment[]) {
        let total: number = payments.reduce(
            (a: number, b) => a + b.Amount, 0);
        //console.log(total);
        return total;
    }
}

export class StudentDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<IStudent[]> = new BehaviorSubject<IStudent[]>([]);

    constructor(
        private studentService: StudentService,
        private schoolYearId: number,
        private userId: string,
        private blockUI: any,
        private translationService: TranslationService,
    ) {
        console.log('this.schoolYearId', this.schoolYearId)
        this.blockUI.start(this.translationService.loading);
        setTimeout(() => {
            this.studentService.getAllByShift(this.schoolYearId, userId).subscribe(response => {
                this.addAll(response);
                this.blockUI.stop();
            }, error => {
                this.blockUI.stop();
            });
        }, 100);
    }

    get data(): IStudent[] {
        return this.dataChange.value;
    }

    public add(store: IStudent) {
        const copiedData = this.data.slice();
        copiedData.push(store);
        this.dataChange.next(copiedData);
    }

    public addAll(store: IStudent[]) {
        this.dataChange.next(store.slice());
    }

    public edit(store: IStudent) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData[index] = store;
        this.dataChange.next(copiedData);
    }

    public delete(store: IStudent) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }

    refresh(event) {
        this.studentService.students = [];
        this.studentService.studentObject = {};
        this.dataChange.next([]);
        setTimeout(() => {
            console.log('this.schoolYearId', this.schoolYearId)
            this.studentService.getAllByShift(this.schoolYearId, this.userId).subscribe(response => {
                for (const r of response) {
                    this.add(r);
                }
                event();
            }, error => {
                event();
            });
        }, 100);
    }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, StoreDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class StudentDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    _divisionId = -1;
    _manually = false;
    _shiftId = -1;
    _curriculumId = -1;
    filteredData: IStudent[] = [];
    renderedData: IStudent[] = [];
    dataLength = 0;

    constructor(
        private _studentDatabase: StudentDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort,
        private _divisionSelected
    ) {
        super();
        this._divisionId = _divisionSelected;

        // Reset to the first page when the store changes the filter.
        this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    filterDivision(divisionId) {
        this._divisionId = divisionId;
        this._filterChange.next(this.filter);
    }

    filterDivisionByManually(manually) {
        this._manually = manually;
        this._filterChange.next(this.filter);
    }

    filterShiftId(shiftId) {
        this._shiftId = shiftId;
        this._filterChange.next(this.filter);
    }

    filterCurriculumId(curriculumId) {
        this._curriculumId = curriculumId;
        this._filterChange.next(this.filter);
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<IStudent[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this._studentDatabase.dataChange,
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            let normalizedFilter = this.normalizeText(this.filter)
            // Filter data
            this.filteredData = this._studentDatabase.data.slice().filter((item: IStudent) => {

                const lastName = (item.LastName).toLowerCase();
                const firstName = (item.FirstName).toLowerCase();
                const document = (item.DocumentNumber).toLowerCase();
                const curriculumId = item.CurriculumId;
                const shiftId = item.ShiftId;
                const divisionId = item.DivisionId;
                const manually = item.Manually;
                
                const normalizeFirstName = this.normalizeText(item.FirstName);
                const normalizeLastName = this.normalizeText(item.LastName);

                const fullName = normalizeFirstName + " " + normalizeLastName;
                const fullNameReverse = normalizeLastName + " " + normalizeFirstName;

                const nombreCompleto = normalizeFirstName + " " + normalizeLastName.split(' ')
                const palabras = normalizedFilter.split(' ')

                return (
                    (
                        normalizedFilter.trim().length == 0 
                        || palabras.every(palabra => nombreCompleto.includes(palabra))
                        || lastName.indexOf(this.filter.toLowerCase()) !== -1
                        || firstName.indexOf(this.filter.toLowerCase()) !== -1
                        || fullName.indexOf(this.filter.toLowerCase()) !== -1
                        || fullNameReverse.indexOf(this.filter.toLowerCase()) !== -1
                        || document.indexOf(this.filter.toLowerCase()) !== -1
                    )
                    && (manually || manually == this._manually)
                    && (this._curriculumId == -1 || curriculumId == this._curriculumId)
                    && (this._shiftId == -1 || shiftId == this._shiftId)
                    && (this._divisionId == -1 || divisionId == this._divisionId)
                );
            });

            console.log(this.filteredData);

            // Sort filtered data
            const sortedData = this.sortData(this.filteredData.slice());

            // Grab the page's slice of the filtered sorted data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            this.dataLength = this._studentDatabase.data.length;
            return this.renderedData;
        });
    }

    normalizeText(text: string): string {
        return text
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .normalize()
            .trim();
    }

    disconnect() {
    }

    /** Returns a sorted copy of the database data. */
    sortData(data: any[]): IStudent[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data.sort((a, b) => {
                const criterios = [
                    a.Course.localeCompare(b.Course),
                    a.LastName.localeCompare(b.LastName),
                    a.FirstName.localeCompare(b.FirstName)
                ];
                return criterios.find(criterio => criterio !== 0) || 0;
            });
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';
            console.log(this._sort.active);
            switch (this._sort.active) {
                case 'LastName':
                    [propertyA, propertyB] = [a.LastName, b.LastName];
                    break;
                case 'FirstName':
                    [propertyA, propertyB] = [a.FirstName, b.FirstName];
                    break;
                case 'DocumentNumber':
                    [propertyA, propertyB] = [a.DocumentNumber, b.DocumentNumber];
                    break;
                case 'Course':
                    [propertyA, propertyB] = [a.Course, b.Course];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/students.component.ts